import { useEffect, useState } from 'preact/hooks';
import { api, type Participant, type Me } from '../lib/api.js';

type Props = { me: Me };

export function Inbox({ me: _me }: Props) {
  const [rows, setRows] = useState<Participant[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    setRows(null);
    try {
      const list = await api<Participant[]>('/api/v1/participants/pending');
      setRows(list);
    } catch (e) {
      setError(String(e));
    }
  }

  useEffect(() => { load(); }, []);

  async function act(id: string, kind: 'accept' | 'decline') {
    try {
      await api(`/api/v1/participants/${id}/${kind}`, { method: 'POST' });
      await load();
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  }

  return (
    <div class="screen">
      <h1>Offen</h1>
      {error ? <div class="error">{error}</div> : null}
      {rows === null ? <p class="muted"><span class="spinner" /></p> : null}
      {rows && rows.length === 0 ? <p class="muted">Keine offenen Zuweisungen.</p> : null}
      <div class="stack">
        {rows?.map((p) => (
          <div class="card">
            <div><strong>{p.role}</strong></div>
            <div class="muted" style={{ marginBottom: 8 }}>
              <a href={`/event/${p.parentEventId}`}>→ Event öffnen</a>
            </div>
            <div class="row">
              <button onClick={() => act(p.id, 'accept')}>✓ Annehmen</button>
              <button class="danger" onClick={() => act(p.id, 'decline')}>✗ Ablehnen</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
